import { showModal } from 'actions';
import { startProgram } from 'actions/Broadcast';
import { BROADCAST_JOIN_MEETING } from '../Types';
import { createConfiguration } from '@studio/chime/configuration/createConfiguration';
import { addDeviceEventObserverToSession } from '@studio/chime/observers/addDeviceEventObserverToSession';
import { commonWebAnalytics } from '@studio/metrics/client/web/commonWebAnalytics';
import {
  realtimeSetCanUnmuteLocalAudio,
  realtimeUnmuteLocalAudio
} from '@studio/chime/audioVideo/audioVideoHelpers';
import { CAMERA_PRESENTER } from '@shoflo/polymer/constants/SourceItems';
import { withCurrentParams } from '../utils';
import { SOURCE_ROLE_SPEAKER } from '@studio/constants/Sources';
import {
  NO_DEVICE_FOUND,
  PERMISSION_DENIED
} from '@studio/constants/ReadinessCheck';
import { SOURCE_CREATE } from '@shoflo/studio-redux/constants/SocketEvents';
import {
  removeSandboxMeetingAttendee,
  getCurrentBroadcast,
  createOrUpdateSource
} from '@shoflo/studio-redux/actions';

/**
 * Join a meeting without knocking
 * @param name
 * @param description
 * @returns {(function(*, *, *): void)|*}
 */
function joinMeetingWithoutKnock(name, description) {
  return withCurrentParams(
    (dispatch, { teamId, eventId, broadcastId }, getState, socket) => {
      const { readinessCheck, user } = getState();
      const sliPayload = {
        presenterName: name,
        pathName: window.location.pathname,
        url: window.location.href
      };
      const action = {
        type: BROADCAST_JOIN_MEETING,
        request: async apiClient => {
          try {
            commonWebAnalytics.startStudioPresenterAddedToChimeMeeting(
              sliPayload
            );
            const { meetingResponse, attendeeResponse } =
              await apiClient.broadcast.createMeeting(
                teamId,
                eventId,
                broadcastId
              );

            const { meetingSession } = createConfiguration(
              meetingResponse,
              attendeeResponse
            );
            const { camera } = readinessCheck || {};

            const sourcePayload = {
              title: name,
              type: CAMERA_PRESENTER,
              value: attendeeResponse.Attendee.AttendeeId,
              order: 1,
              description,
              userId: user._id,
              role: SOURCE_ROLE_SPEAKER,
              cameraUnavailable:
                camera === NO_DEVICE_FOUND || camera === PERMISSION_DENIED
            };
            dispatch(createOrUpdateSource(sourcePayload));

            const notifyingDirector = attendeeResponse?.Attendee.AttendeeId;
            socket.emit(SOURCE_CREATE, {
              broadcastId,
              notifyingDirector
            });
            addDeviceEventObserverToSession(
              dispatch,
              showModal,
              meetingSession
            );
            await realtimeSetCanUnmuteLocalAudio(meetingSession, true);
            await realtimeUnmuteLocalAudio(meetingSession);
            commonWebAnalytics.endStudioPresenterAddedToChimeMeeting(
              sliPayload
            );
            return {
              meetingResponse,
              attendeeResponse,
              meetingSession
            };
          } catch (e) {
            commonWebAnalytics.endStudioPresenterAddedToChimeMeeting({
              ...sliPayload,
              error: e?.message
            });
            throw e;
          }
        }
      };
      dispatch(action);
      dispatch(removeSandboxMeetingAttendee());
      dispatch(startProgram());
      dispatch(getCurrentBroadcast());
    }
  );
}

export default joinMeetingWithoutKnock;
